
import { useState, createRef } from "react";
import { Marker } from 'react-map-gl';

import './style.scss'

const OverLappingPins = ({ pins, index, mapRefs, overlappingPinsRefs, config, handleMarkerClick }) => {
    const [isCollapsed, setIsCollapsed] = useState(false);

    return (
        <Marker longitude={pins[0].longitude} latitude={pins[0].latitude}>
            <div ref={overlappingPinsRefs.current[index]} className='overlapping-pins'>
                <div className='markers'>
                    <div className='primary-marker' style={config?.overlappingPinsOptions?.pinStyles?.primaryPin} onClick={() => handleMarkerClick(pins[0]?.markerIndex)} ref={mapRefs?.current[pins[0]?.markerIndex] ?? createRef()}> {pins[0]?.children?.mapChildren}</div>
                    <div className={`secondary-markers ${isCollapsed ? 'collapsed' : ''}`} style={config?.overlappingPinsOptions?.pinStyles?.secondaryPinWrapper}>
                        <div>
                            {pins.map((marker, i) => (
                                <div key={i} style={config?.overlappingPinsOptions?.pinStyles?.secondaryPin} onClick={() => handleMarkerClick(marker?.markerIndex)} ref={mapRefs?.current[marker?.markerIndex] ?? createRef()}>{marker?.children?.mapChildren}</div>
                            ))}
                        </div>

                        {pins.length > 3 &&
                            <div onClick={() => setIsCollapsed(!isCollapsed)} className='collapse'>
                                {isCollapsed ? <i className="icon-arrow-right"></i> : <i className="icon-x"></i>}
                            </div>
                        }
                    </div>
                </div>
            </div>
        </Marker>
    )
}

export default OverLappingPins